<div class="search-wrapper">
  <mat-icon>search</mat-icon>
  <input
    #searchInput
    (input)="emitSearchChange($event)"
    placeholder="{{ placeholder() }}"
    type="text"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
  />
</div>
<ng-content></ng-content>
